// discount-code js
// document.querySelectorAll('.success-msg-main').forEach(success => {
// 	success.style.display="none";
// })
// document.querySelectorAll('.discount-code-desc-inner').forEach(offer => {
// 	offer.addEventListener('click', (e) => {
// 		var current = e.currentTarget;
// 		var nextcurrent = e.currentTarget.nextElementSibling;
// 		var loaderclass = e.currentTarget.previousElementSibling;
// 		var discount_code = e.currentTarget.getAttribute('data-id');
// 		loaderclass.style.display = "flex";
// 		current.style.display="none";
// 		fetch(`/discount/${discount_code}`,{
// 			method: 'GET',
// 		})
// 		.then(response => {
// 			loaderclass.style.display="none";
// 			current.style.display = "none";
// 			nextcurrent.style.display = "flex";
      
// 			setTimeout(function() {
// 				current.style.display = "flex";
// 				nextcurrent.style.display = "none";
// 			}, 4000);
// 		})
// 	})
// })

// -----------------------
// 1. Toggle Section Visibility
// -----------------------
// document.querySelector(".view-all-link")?.addEventListener("click", function (e) {
//     e.preventDefault();

//     const applySection = document.querySelector(".apply-coupon-wrapper");
//     const discountSection = document.querySelector(".discount-code-wrapper");

//     if (applySection) applySection.style.display = "none";
//     if (discountSection) discountSection.style.display = "block";
// });

// document.querySelector(".close-icon-wrap")?.addEventListener("click", function (e) {
//     e.preventDefault();

//     const applySection = document.querySelector(".apply-coupon-wrapper");
//     const discountSection = document.querySelector(".discount-code-wrapper");

//     if (applySection) applySection.style.display = "block";
//     if (discountSection) discountSection.style.display = "none";
// });

document.addEventListener('click', function(e) {
    const link = e.target.closest('.view-all-link');
    if (!link) return;

    e.preventDefault();

    const applySection = document.querySelector(".apply-coupon-wrapper");
    const discountSection = document.querySelector(".discount-code-wrapper");

    if (applySection) applySection.style.display = "none";
    if (discountSection) discountSection.style.display = "block";
});

document.addEventListener('click', function (e) {
    const closeBtn = e.target.closest('.close-icon-wrap');
    if (closeBtn) {
        e.preventDefault();

        const applySection   = document.querySelector(".apply-coupon-wrapper");
        const discountSection = document.querySelector(".discount-code-wrapper");

        if (applySection)   applySection.style.display   = "block";
        if (discountSection) discountSection.style.display = "none";
    }
});


// -----------------------
// 2. Discount Code Click Logic
// -----------------------
document.querySelectorAll('.success-msg-main').forEach(success => {
    success.style.display="none";
});

document.querySelectorAll('.discount-code-desc-inner').forEach(offer => {
    offer.addEventListener('click', (e) => {
        var current = e.currentTarget;
        var nextcurrent = e.currentTarget.nextElementSibling;
        var loaderclass = e.currentTarget.previousElementSibling;
        var discount_code = e.currentTarget.getAttribute('data-id');

        loaderclass.style.display = "flex";
        current.style.display="none";

        fetch(`/discount/${discount_code}`, { method: 'GET' })
        .then(response => {
            loaderclass.style.display="none";
            current.style.display = "none";
            nextcurrent.style.display = "flex";

            setTimeout(function() {
                current.style.display = "flex";
                nextcurrent.style.display = "none";
            }, 4000);
        });
    });
});


document.addEventListener('click', function (e) {
    const offer = e.target.closest('.discount-code-desc-inner');
    if (!offer) return;

    e.preventDefault();

    const discountCode   = offer.getAttribute('data-id');
    const loader         = offer.previousElementSibling;        
    const successMessage = offer.nextElementSibling;            

    if (!discountCode || !loader || !successMessage) return;

    // Show loader, hide the offer text
    loader.style.display = "flex";
    offer.style.display = "none";

    fetch(`/discount/${discountCode}`, { 
        method: 'GET',
        headers: { "X-Requested-With": "XMLHttpRequest" }
    })
    .then(response => {
        // Hide loader
        loader.style.display = "none";

        if (response.ok) {
            successMessage.style.display = "flex";

            setTimeout(() => {
                successMessage.style.display = "none";
                offer.style.display = "flex";
            }, 4000);

        } else {
            offer.style.display = "flex";
            alert("This coupon is no longer valid."); 
        }
    })
    .catch(err => {
        console.error("Discount apply failed:", err);
        loader.style.display = "none";
        offer.style.display = "flex";
        alert("Something went wrong. Please try again.");
    });
});


// -----------------------
// 3. APPLY Button (Use Same Discount Logic)
// -----------------------
// document.getElementById("coupon-apply-btn")?.addEventListener("click", function () {
//     var code = document.getElementById("coupon-code-input").value.trim();
    
//     if (code.length > 0) {

//         // Show loading animation (optional)
//         console.log("code-1" , code);
        
//         const loader = document.querySelector(".coupon-loader");
//         if (loader) loader.style.display = "flex";

//         fetch(`/discount/${code}`, { method: "GET" })
//         .then(response => {

//             // Hide loader
//             if (loader) loader.style.display = "none";

//             // You can show success or error message here
//             console.log("Discount applied:", code);

//         });
//     }
// });
// document.getElementById("coupon-apply-btn")?.addEventListener("click", function () {
//     var code = document.getElementById("coupon-code-input").value.trim();
//     if (code.length > 0) {

//         const btn = document.getElementById("coupon-apply-btn");
//         const btnText = btn.querySelector(".btn-text");
//         const btnLoader = btn.querySelector(".btn-loader");

//         // Hide text, show loader
//         btnText.style.display = "none";
//         btnLoader.style.display = "inline-block";

//         fetch(`/discount/${code}`, { method: "GET" })
//         .then(response => {
//             // restore button after success
//             btnText.style.display = "inline-block";
//             btnLoader.style.display = "none";
//         })
//         .catch(err => {
//             // restore button after error too
//             btnText.style.display = "inline-block";
//             btnLoader.style.display = "none";
//         });
//     }
// });

document.addEventListener('click', function (e) {
    const applyBtn = e.target.closest('#coupon-apply-btn');
    if (!applyBtn) return; // Not our button

    e.preventDefault(); // in case it's a submit button inside a form

    const codeInput   = document.getElementById("coupon-code-input");
    const errorBox    = document.getElementById("coupon-error-msg");
    const btnText     = applyBtn.querySelector(".btn-text");
    const btnLoader   = applyBtn.querySelector(".btn-loader");

    // Safety checks
    if (!codeInput) return;

    const code = codeInput.value.trim();

    // Clear previous error/success
    if (errorBox) {
        errorBox.style.display = "none";
        errorBox.innerText = "";
    }

    if (code.length === 0) {
        if (errorBox) {
            errorBox.innerText = "Please enter a coupon code.";
            errorBox.style.display = "block";
        }
        return;
    }

    // Show loader
    if (btnText)   btnText.style.display   = "none";
    if (btnLoader) btnLoader.style.display = "inline-block";

    // Disable button to prevent double-click (optional but recommended)
    applyBtn.disabled = true;

    fetch(`/discount/${code}`, { 
        method: "GET",
        headers: { "X-Requested-With": "XMLHttpRequest" } // helps Shopify recognize AJAX
    })
    .then(async response => {
        console.log('first response');
console.log(response);
        const isJson = response.headers.get("content-type")?.includes("application/json");
        const data = isJson ? await response.json() : null;

        // Always hide loader
        if (btnText)   btnText.style.display   = "inline-block";
        if (btnLoader) btnLoader.style.display = "none";
        applyBtn.disabled = false;

        if (!response.ok) {
            // Shopify usually returns 422 or 404 for invalid codes
            const message = data?.message || "Invalid coupon code. Please try again.";
            if (errorBox) {
                errorBox.innerText = message;
                errorBox.style.display = "block";
            }
        } else {
            if (errorBox) {
                errorBox.innerText = "Discount applied successfully!";
                errorBox.style.display = "block";
                errorBox.style.color = "green"; // optional success style
            }

            // Optional: refresh cart or trigger Shopify refresh
            if (typeof Shopify !== "undefined") {
                // For Shopify – trigger cart update
                document.dispatchEvent(new CustomEvent("cart:refresh"));
                // Or reload the cart drawer/section
                fetch(window.Shopify.routes.root + "?section_id=cart-drawer")
                    .then(r => r.text())
                    .then(html => {
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(html, "text/html");
                        const newDrawer = doc.querySelector(".cart-drawer"); // adjust selector
                        if (newDrawer) {
                            document.querySelector(".cart-drawer")?.replaceWith(newDrawer);
                        }
                    });
            }
        }
    })
    .catch(err => {
        console.error("Coupon apply error:", err);
        if (btnText)   btnText.style.display   = "inline-block";
        if (btnLoader) btnLoader.style.display = "none";
        applyBtn.disabled = false;

        if (errorBox) {
            errorBox.innerText = "Something went wrong. Please try again.";
            errorBox.style.display = "block";
        }
    });
});



